//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CalloutModeType",1,0],[0,"LayoutType",1,0],[1,"SelectCallout",0,"SelectDisplayableObjectList",0],[0,"VerticalLeaderAttachment",1,0]],[[["symbolCount"],"GetGroupSymbols",{R_:{symbols:"Annotations.IdSymbol[]"}},0,0],[["symbols"],"SetGroupSymbols",{},1,0]],[]];
SPLM.Annotations.CalloutGroupBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.CalloutGroupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.CalloutGroupBuilder.Layout = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

SPLM.Annotations.CalloutGroupBuilder.Mode = Object.freeze({
    "Group" : "Group", "Ungroup" : "Ungroup"});

SPLM.Annotations.CalloutGroupBuilder.VerticalGroupLeaderAttachment = Object.freeze({
    "Top" : "Top", "Bottom" : "Bottom"});

export default SPLM;